import React, { Component } from "react";
import "./style.css";
import "../../../../../../index.css";
class SchoolContact extends Component {
  render() {
    const { visible, data } = this.props;
    return data === null ? (
      ""
    ) : (
      <div
        className="schoolContact_box"
        style={{ display: visible === true ? "block" : "none" }}
      >
        <div className="schoolContact_box_tip">
          点击下方网址有未统一公开的数据哦
        </div>
        <div className="schoolContact_box_title major_top_16">学校官网</div>
        <div className="schoolContact_box_content">
          <a target="_blank" href={data.url}>
            {data.url}
          </a>
        </div>
        <div className="schoolContact_box_title major_top_18">招生办网址</div>
        <div className="schoolContact_box_content">
          <a target="_blank" href={data.admissionsUrl}>
            {data.admissionsUrl}
          </a>
        </div>
        <div className="schoolContact_box_title major_top_16">联系电话</div>
        <div className="schoolContact_box_content">{data.admissionsPhone}</div>
        <div className="schoolContact_box_title major_top_16">学校地址</div>
        <div className="schoolContact_box_content">{data.address}</div>
      </div>
    );
  }
}

export default SchoolContact;



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolDetailDown/components/SchoolContact/index.js